module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_BlogPostEvent Widget

(function (fox, $) {
	'use strict';
	fox.registerWidget('Activity_Event_BlogPostEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_blogpost'
			});
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84); 
			});
			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		},

		rendering: function () {
			fox.each(this.templateOptions.eventTypedParams.contents, function (val, key) {
				if (val.type === 1) {
					var $img = $(val.content).find('img');
					if ($img.length) {
						val.content = $img[0].src;
						this.templateOptions.eventTypedParams.contents[key].content = val.content;
			
					}
					else {
						this.templateOptions.eventTypedParams.contents[key].text = val.content;
						this.templateOptions.eventTypedParams.contents[key].content = '';
					}
					
				}
				if (val.type === 3 && new RegExp(/(;base64,)/gi).test(val.content)) {
					this.templateOptions.eventTypedParams.contents[key].content = JSON.parse(val.content);
				}

			}, this);
		
			this.callParent('rendering', arguments);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/blogPostEvent.js
// module id = 815
// module chunks = 4